// ─────────────────────────────────────────────
// Crop and Fertilizer Blend Options
// Contains the list of crops and fertilizer
// blends available for the recommendation tool.
//
// Adding a new crop or blend in the future is
// as simple as adding a new entry to the array.
// ─────────────────────────────────────────────

// Crops the farmer can select from
export const CROP_OPTIONS = [
  { value: "cowpea", label: "crops.cowpea" },
  { value: "maize", label: "crops.maize" },
  { value: "sorghum", label: "crops.sorghum" },
  { value: "soyabean", label: "crops.soyabean" },
];

// Fertilizer blends the farmer can choose between
// The ratio represents N : P : K proportions
export const FERTILIZER_BLEND_OPTIONS = [
  { value: "20:10:10", label: "20 : 10 : 10" },
  { value: "15:15:15", label: "15 : 15 : 15" },
];
